import { render, staticRenderFns } from "./TipoPartes.vue?vue&type=template&id=0fd44e12"
import script from "./TipoPartes.vue?vue&type=script&lang=js"
export * from "./TipoPartes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports